module.exports = __webpack_public_path__ + "img/W7009-full.0dab6891.jpg";